exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LastUpdateTime__container___1_mg8 {\n  height: 17px;\n  font-size: 12px;\n  line-height: 1.42;\n  color: #5d7186;\n}\n", ""]);

// exports
exports.locals = {
	"container": "LastUpdateTime__container___1_mg8"
};